import React, { useState } from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { SelectedProduct } from "~/common/Store/models/ProductListing";
import AddToCartButton from "../productListing/ProductBox/AddToCart";
import { defaultUserObject } from "~/common/Store/rootReducer";
import { ShopTheLookProductTag } from "~/common/Store/models/Brand";

interface Props {
  tag: ShopTheLookProductTag;
  setActiveTagIndex: React.Dispatch<React.SetStateAction<number | null>>;
  isMobile: boolean;
  activeProductCardRef: React.RefObject<HTMLDivElement>;
}
const ShopProductCard = ({
  tag,
  setActiveTagIndex,
  isMobile,
  activeProductCardRef,
}: Props) => {
  const { product } = tag;
  const [selectedProduct, setSelectedProduct] = useState<SelectedProduct>({
    ...product,
    activeSale: product.price.displaySalePrice,
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
  });
  const productCardContent = (
    <div ref={activeProductCardRef}>
      <a
        href={product.link}
        data-target="title"
        className="description companionItemClicked"
        title={product.description}
      >
        {product.description}
      </a>
      {selectedProduct.price.price > 0 && (
        <div className="pricing" data-component="Pricing">
          <p className="price">
            {` ${formatAsCurrency.formatIfUndefined(
              selectedProduct.price.price,
            )} `}
            {selectedProduct.unitOfMeasure && (
              <span className="each">
                {` / ${selectedProduct.unitOfMeasure}`}
              </span>
            )}
          </p>
        </div>
      )}
      <AddToCartButton
        {...{
          product,
          user: defaultUserObject,
          selectedProduct,
          setSelectedProduct,
          isCarouselProductBox: true,
        }}
      />
      <div className="ribbon-stack">
        <a href="/plus/" className="ribbon ribbon--mini ribbon--plus">
          <span className="ribbon__text">plus</span>
        </a>
      </div>
    </div>
  );

  return (
    <div
      id="productTray"
      className="ag-offcanvas active"
      data-component="shopLookTray"
      style={
        isMobile
          ? {}
          : {
              left: `calc(${tag.xPosition}% - 100px)`,
              top: `calc(${tag.yPosition}% - 150px)`,
            }
      }
    >
      <div
        id="shopTheLookProduct"
        className="hotspot-tag__product-card ag-item"
      >
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
        <div
          className="hotspot-tag__close icon-cancel"
          onClick={() => setActiveTagIndex(null)}
        />
        <div className="ag-offcanvas__content">
          <>
            <div className="product-image">
              <a
                href={product.link}
                className="image companionItemClicked"
                title={product.description}
              >
                <img alt={product.description} src={product.primaryImagePath} />
              </a>
            </div>
            {isMobile ? (
              <div className="ag-offcanvas__info">{productCardContent}</div>
            ) : (
              productCardContent
            )}
          </>
        </div>
      </div>
    </div>
  );
};

export default ShopProductCard;
